import React from "react";
import {AppStore} from "./AppStore";
import {DisposeUtils} from "../utils/DisposeUtils";
import {ErrorUtils} from "../utils/ErrorUtils";
import {proto} from "../proto/messages";
import {makeAutoObservable} from "mobx";
import {lessons} from "../proto/compiled";

export const LessonsStoreContext = React.createContext<LessonsStore | undefined>(undefined);

export class LessonsStore {
  private disposer = new DisposeUtils();
  private app: AppStore;
  private loadPending = false;
  loading = false;
  lessons?: lessons.IListLessonsResponse;
  private pageSize?: number;

  constructor(app: AppStore, pageSize?: number) {
    this.app = app;
    this.pageSize = pageSize;
    this.load();
    makeAutoObservable(this);
  }

  dispose() {
    this.disposer.dispose();
  }

  async load() {
    if (this.loading) {
      this.loadPending = true;
      return;
    }
    this.loading = true;
    await this.app.socketApiConnectedAndAuthenticated;
    try {
      this.lessons = (await this.app.socketApi.fetch(
        proto.TxListLessons.create({pagination: {pageSize: this.pageSize}}),
        new proto.RxListLessonsResponse(),
      )).proto;
    } catch (e) {
      ErrorUtils.fromFetch(e);
    }
    this.loading = false;
    if (this.loadPending) {
      this.loadPending = false;
      this.load();
    }
  }
}
